import { createLabeledMessages } from '../../../messageUtils';
const address = {
    address: 'adresa',
    mailingAddress: 'korešpodenčná adresa',
    place: 'miesto',
    city: 'mesto',
    street: 'ulica',
    village: 'obec',
    villagePart: 'časť obce',
    postalCode: 'poštové smerovacie číslo',
    postalCode_short: 'PSČ',
    buildingNumber: 'číslo popisné',
    buildingNumber_short: 'ČP',
    orientationNumber: 'číslo orientačné',
    flatZone: 'povodňová zóna',
    regionZone: 'regionálna zóna'
};
export default Object.assign({}, address, createLabeledMessages(address));
